import { Component, computed, inject, input, model, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormPopupComponent } from '../utils/form-popup/form-popup.component';
import { DxFormModule } from 'devextreme-angular';
import { DxiItemModule, DxoLabelModule } from 'devextreme-angular/ui/nested';
import { FormTextboxComponent } from '../utils/form-textbox/form-textbox.component';
import { AppInfoService, AuthService } from 'src/app/services';
import { alert, confirm } from 'devextreme/ui/dialog';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-change-password',
    imports: [CommonModule, FormPopupComponent, DxFormModule, DxiItemModule, DxoLabelModule, FormTextboxComponent],
    template: `
    <form-popup
      titleText="Change Password"
      [visible]="visible()"
      [width]="360"
      [height]="225"
      [wrapperAttr]="{ class: 'change-profile-password-popup' }"
      [isSaveDisabled]="isSaveDisabled()"
      (save)="saveNewPassword()"
      (visibleChange)="changeVisible($event)"
    >
      <dx-form #form labelMode="outside" labelLocation="top" [showColonAfterLabel]="false">
        <dxi-item>
          <dxo-label text="New Password"></dxo-label>
          <form-textbox placeholder="Password" stylingMode="filled" [(value)]="newPassword" [isEditing]="true" />
        </dxi-item>
      </dx-form>
    </form-popup>
  `,
    styles: []
})
export class ChangePasswordComponent {
  userService = inject(UserService);
  appInfo = inject(AppInfoService);

  userId = input.required<string>();
  visible = model.required<boolean>();

  newPassword = signal<string>('');
  isSaveDisabled = computed(() => !this.newPassword());

  async saveNewPassword() {
    this.appInfo.isLoading.set(true);
    var result = await this.userService.changePassword(this.userId(), this.newPassword());
    this.appInfo.isLoading.set(false);
    if (!result.isSuccess) {
      alert(result.errors?.map((error) => error.errorMessage).join('<br>'), 'Error Changing Password');
      return;
    }
    alert('The password for this user was changed.', 'Password Changed');
  }

  changeVisible(visible: boolean): void {
    this.visible.set(visible);
  }
}
